module.exports = __webpack_public_path__ + "assets/images/1$L-route-sheet.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/1$L-route-sheet.png
// module id = 1271
// module chunks = 1